import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RedeemIcon(props: IconProps) {
    return <Icon {...props} iconKey={"redeem"}/>
}
